import { clearReliableTimeout, setReliableTimeout } from './reliabletimer';

const reliableIntervalIds: { [key: string]: string } = {};

/**
 * Use this utility to invoke a function every specified number of milliseconds.
 * When the document's visibility is changed from hidden to visible and
 * the time elapsed is >= the specified delay and the wrapped function hasn't yet run, invoke the function.
 */
export function setReliableInterval(wrappedFunc: () => void, delay: number, id?: string): string {
    const requestId: string = id || 'RI_' + Math.random();
    reliableIntervalIds[requestId] = setReliableTimeout(function () {
        wrappedFunc && wrappedFunc();
        setReliableInterval(wrappedFunc, delay, requestId);
    }, delay);
    return requestId;
}

/**
 * Use this utility to clear a timer set with setReliableInterval
 */
export function clearReliableInterval(id: string) {
    const rID = reliableIntervalIds[id];
    if (rID) {
        clearReliableTimeout(rID);
        delete reliableIntervalIds[id];
    }
}
